/* global I18n */

import React, {useState} from "react"
import ExamSummary from "./exam_summary"
import StudySummary from "./study_summary"

function QuizSummary({
  description,
  last_training_in_words,
  exam_training_stats,
  study_training_stats,
  open_quiz_mode_modal,
  revise_exam_quiz,
  can_train
}) {
  const trained_study_and_exam = study_training_stats && exam_training_stats
  const exam_stats_updated_at = exam_training_stats?.updated_at ?? 0
  const study_stats_updated_at = study_training_stats?.updated_at ?? 0
  const five_minutes_ago = Date.now() - 300000
  const [active, set_active] = useState(() => initial_summary_mode())

  function initial_summary_mode() {
    if (!study_training_stats) return "exam"

    // Show study mode stats unless returning from the trainer
    // (summary param present in embedded quizzes, but not in custom quizzes)
    if (!(new URL(window.location)).searchParams.get("summary")) {
      return choose_summary_mode()
    }

    return exam_stats_updated_at > study_stats_updated_at ? "exam" : "study"
  }

  function choose_summary_mode() {
    if (new Date(exam_stats_updated_at).getTime() > five_minutes_ago &&
      exam_stats_updated_at > study_stats_updated_at) {
      return "exam"
    }
    return "study"
  }

  return (
    <div className="embedded-quiz-summary">
      <div className="tiny text-center hide-md-lg-only">
        <div className="title">
          {description}
        </div>
        <div className="meta">
          {I18n.t("js.new_embedded_quiz.quizzed_time_ago",
            {time: last_training_in_words})}
        </div>
      </div>
      <div className="btn-toggle-group">
        {trained_study_and_exam && <div className="container">
          <button className={`toggle ${active === "study" ? "active" : ""}`}
                  onClick={() => set_active("study")}>
            {I18n.t("js.new_embedded_quiz.study")}
            {active !== "study" && <div className="subtitle">
              {I18n.t("js.new_embedded_quiz.time_ago",
                {
                  time: study_training_stats.last_study_session_in_words_short
                })}
            </div>}
          </button>
          <button className={`toggle ${active === "exam" ? "active" : ""}`}
                  onClick={() => set_active("exam")}>
            {I18n.t("js.new_embedded_quiz.exam")}
            {active !== "exam" && <div className="subtitle">
              {I18n.t("js.new_embedded_quiz.time_ago",
                {time: exam_training_stats.last_exam_quiz_in_words_short})}
              {" · "}
              {exam_training_stats.success_rate}%
            </div>}
          </button>
        </div>}
      </div>
      {active === "exam" && <ExamSummary
        exam_training_stats={exam_training_stats}
        open_quiz_mode_modal={open_quiz_mode_modal}
        revise_exam_quiz={revise_exam_quiz}
        can_train={can_train}
      />}
      {active === "study" &&
        <StudySummary
          stats={study_training_stats}
          open_quiz_mode_modal={open_quiz_mode_modal}
          can_train={can_train}
        />}
    </div>
  )
}

export default QuizSummary
